import React, { useState } from 'react';
import Form from '../../molecules/Form/Form';
import Field from '../Field';
import { useForm } from '../../molecules/Form';
import { handleOnDrop } from '../../../helpers/common';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Toast from '../../molecules/Toast';
import { GoArrowLeft } from 'react-icons/go';
import Button from '../../molecules/Button';
import Step2 from '../CreateCompaign/Step2';
import { StyledCampaignTask } from '../CreateCompaign/CreateCompaign.styles';

const AddMoreLeads = () => {
  const [form] = useForm();
  const [formData, setFormData] = useState(null);
  const [addMoreLeads, setAddMoreLeads] = useState(false);
  const [data, setData] = useState(null);
  const { user, fetch } = useContextHook(AuthContext, v => ({
    user: v.user,
    fetch: v.fetch,
  }));

  const handelSubmit = e => {
    const step1Data = {
      ...e,
      rowLenght: formData?.rowData,
      columnNames: formData?.columnNames,
      rows: formData?.rows,
      campaign_name: e.campaign_name,
    };

    setData(prev => ({
      ...prev,
      step1: step1Data,
    }));
    setAddMoreLeads(true);
  };

  return (
    <>
      <div className="steps-holder">
        {!addMoreLeads ? (
          <>
            <div className="head">
              <button onClick={() => window.history.back()}>
                <GoArrowLeft size={25} />
              </button>
              <div>
                <span className="heading">Add more leads</span>
                <p>Step 1 of 2: Add/Upload Leads</p>
              </div>
            </div>
            <Form form={form} onSubmit={handelSubmit}>
              <Form.Item
                type="csv"
                label="Upload your CSV file"
                rounded
                name="csvfile"
                placeholder="csv file"
                rules={[
                  {
                    required: true,
                    message: 'File is required to continue',
                  },
                ]}
                bg
                disc="Limit 200MB per file • CSV"
                uploadTitle="Drag & Drop or choose file to upload"
                fileSize={20}
                icon
                accept=".xlsx , .csv"
                onUploadAccepted={(rawData, file) => handleOnDrop(rawData, file, user, setFormData, form, Toast)}>
                <Field />
              </Form.Item>
              <div className="btn-holder">
                <Button variant="dark">Next</Button>
              </div>
            </Form>
          </>
        ) : (
          <Step2 data={data} addMoreLeads={addMoreLeads} setAddMoreLeads={setAddMoreLeads} />
        )}
      </div>
    </>
  );
};

export default AddMoreLeads;
